/* eslint-disable require-jsdoc */
import React from 'react';
import PropTypes from 'prop-types';
import {isValid} from '../../utils/validate';


const Genre = (props) => {
  return (
    <div className="hearby-carousel-controls-item hearby-cci-genre">
      <select name="genre"
        onChange={props.change}
        className="hearby-cc-select-menu hearby-genre"
        defaultValue={isValid(props.defaultGenreValue) ?
          props.defaultGenreValue :'-1'}
      >
        <option value="-1">All Genres</option>
        <option value="alternative">
          Alternative
        </option>
        <option value="blues">Blues</option>
        <option value="comedy">Comedy</option>
        <option value="electronic">
          EDM & Electronic
        </option>
        <option value="folk">Folk</option>
        <option value="instrumental">Instrumental</option>
        <option value="international">
          International
        </option>
        <option value="jazz" >Jazz</option>
        <option value="pop">Pop</option>
        <option value="rap&amphip-hop">Rap & Hip-Hop</option>
        <option value="rock">Rock</option>
        <option value="vocal">Vocal</option>
        {/* <option value="country" >Country</option> */}
      </select>
      {/* {console.log('genre props: ', props)} */}
    </div>
  );
};

Genre.propTypes = {
  change: PropTypes.func.isRequired,
  defaultGenreValue: PropTypes.string.isRequired,
};

export default Genre;
